module.exports = __webpack_public_path__ + "static/img/weixin_pay3.c9224396.jpg";